interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  {
    name: 'rd',
    src:
      'https://d335luupugsy2.cloudfront.net/js/loader-scripts/30766d7f-ddb7-488d-8347-6d6560019003-loader.js',
  },
];
